import accordion from "../../resources/js/module/accordion";
import faqFilterByCategory from "../../resources/js/module/faqFilterByCategory";
import faqsLoadMore from "../../resources/js/module/faqsLoadMore";

$(document).ready(function () {
  const accordions = document.querySelectorAll('.accordion');
  if (accordions) {
    accordions.forEach(acc => {
      accordion(acc);
    });
  }

  const faq = document.querySelector('.tr-faq-filters__faq');
  if (faq) {
    faq.addEventListener('click', function ({target}) {
      if (target.classList.contains('load-more-faq-btn')) {
        faqsLoadMore(target);
      }
    });
  }

  faqFilterByCategory();
})
